<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filial"
          label="Filial"
          outlined
          hide-details
          multiple
        />
      </div>
    </div>

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import $axios from "@/api/api";

export default {
  name: "RelatorioFilialPorCurvasPQR",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      filial: [],
      segmentos: [],
      fornecedores: [],
    }
  }),
  watch: {
    DIALOG_ATIVO() {
      if (!this.DIALOG_ATIVO) {
        this.filtros.grupos = [];
        this.filtros.filial = [];
        this.filtros.segmentos = [];
        this.filtros.fornecedores = [];
      }
    }
  },
  methods: {
    gerarRelatorio() {
      const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
